import { render, staticRenderFns } from "./InputVideo.vue?vue&type=template&id=13b488c6&scoped=true&"
import script from "./InputVideo.vue?vue&type=script&lang=js&"
export * from "./InputVideo.vue?vue&type=script&lang=js&"
import style0 from "./InputVideo.vue?vue&type=style&index=0&id=13b488c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b488c6",
  null
  
)

export default component.exports